import { Component, OnInit, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertService, LoadingService } from 'ngx-kuv-tools';
import { ConfigService } from 'src/app/utils/config/config.service';
import { FormatterService } from 'src/app/utils/formatter/formatter.service';
import { ModalDeleteComponent } from 'src/app/utils/modal-delete/modal-delete.component';
import { SesionService } from 'src/app/utils/sesion/sesion.service';
import { ProductoCreateComponent } from '../producto-create/producto-create.component';
import { ProductoUpdateComponent } from '../producto-update/producto-update.component';
import { ProductoViewComponent } from '../producto-view/producto-view.component';
import { ProductoService } from '../producto.service';
import { CategoriaService } from '../../categoria/categoria.service';

@Component({
  selector: 'app-producto-index',
  templateUrl: './producto-index.component.html',
  styleUrls: ['./producto-index.component.scss']
})
export class ProductoIndexComponent implements OnInit {
  columnas: any[] = [
    {
      label: "Nombre",
      attribute: "nombre",
      responsive: ['XS', 'SM', 'MD'],
      width: 1
    },
    {
      label: "Descripción",
      width: 3,
      attribute: "descripcion",
      responsive: ['MD'],
    },
    {
      label: "Stock",
      width: 1,
      attribute: "stock",
      responsive: ['SM', 'MD'],
      value: (element: any) => {
        return this.formatter.numberFormat(element.stock_local)
      }
    },
    {
      label: "Precio Venta",
      attribute: "precio_venta",
      width: 1,
      responsive: ['XS', 'SM', 'MD'],
      value: (element: any) => {
        return '$ ' + this.formatter.numberFormat(element.precio_venta)
      }
    },
    // {
    //   label: "Moneda",
    //   width: 1,
    //   attribute: "moneda",
    //   responsive: ['MD'],
    //   value: (element: any) => {
    //     switch (element.moneda) {
    //       case 1:
    //         return 'CLP';
    //       case 2:
    //         return 'USD';
    //       case 3:
    //         return 'UF';
    //       default:
    //         return null;
    //     }
    //   }
    // },
    {
      label: "Categoría",
      width: 1,
      attribute: 'categoria',
      responsive: ['MD'],
      value: (el: any) => {
        return el.categorias?.nombre;
      }
    },
    {
      label: "Estado",
      width: 1,
      attribute: "estado",
      responsive: ['XS', 'SM', 'MD'],
      styled: true,
      value: (element: any) => {
        if (element.estado == 1) {
          return '<h5><span class="badge bg-primary">Activo</span></h5>';
        } else {
          return '<h5><span class="badge bg-secondary">Inactivo</span></h5>';
        }
      }
    }
  ]
  acciones: any[] = [

    {
      label: 'Detalle',
      icon: 'eye',
      action: (element: any, index: number) => {
        this.view(element.id);
      }
    },
    {
      label: 'Editar',
      icon: 'pen',
      action: (element: any, index: number) => {
        this.update(element);
      }
    },
    {
      icon: "toggle-on",
      label: "Activar",
      action: (element: any) => {
        this.cambiarEstado(element);
      },
      hide: (element: any, index: number) => {
        return element.estado == -1;
      }
    },
    {
      icon: "toggle-off",
      label: "Desactivar",
      action: (element: any) => {
        this.cambiarEstado(element);
      },
      hide: (element: any, index: number) => {
        return element.estado == 1;
      }
    }, {
      label: 'Eliminar',
      icon: 'trash',
      action: (element: any, index: number) => {
        this.delete(element);
      }
    }
  ]

  filtros: any[] = [
    {
      label: 'Nombre',
      op: 'substring',
      column: 'nombre'
    },
    {
      label: 'Descripción',
      op: 'substring',
      column: 'descripcion'
    },
    {
      label: 'SKU',
      op: 'substring',
      column: 'sku'
    },
    {
      label: 'Categoría',
      column: 'categoria_id',
      op: 'eq',
      type: 'select',
      options: [] as { label: string; value: number; }[],
    },
    {
      label: 'Código de Barras',
      op: 'substring',
      column: 'codigo_barra'
    }
  ]

  user = JSON.parse(localStorage.getItem('usuario') as string);
  reloadEmitter: EventEmitter<string> = new EventEmitter();
  constructor(
    public config: ConfigService,
    public formatter: FormatterService,
    private loading: LoadingService,
    private alerts: AlertService,
    private modalService: NgbModal,
    public service: ProductoService,
    public sesion: SesionService,
    public categoriaService: CategoriaService
  ) {
    this.selectCategoria()
  }

  ngOnInit(): void {
  }

  agregar() {
    this.modalService.open(ProductoCreateComponent, { size: 'lg', scrollable: true, backdrop: 'static' }).result.then((result: any) => {
      this.reloadEmitter.emit('true');
    }, (reason: any) => { });
  }

  view(id: number) {
    this.loading.show()
    this.service.setID(id)
    this.service.view(id).subscribe((res: any) => {
      this.loading.hide();
      const modalRef = this.modalService.open(ProductoViewComponent, { size: 'lg', scrollable: true });
      modalRef.componentInstance.element = res
      modalRef.result.then((result) => { }, (reason) => { });
    });
  }

  update(element: any): void {
    this.loading.show()
    this.service.view(element.id).subscribe({
      next: (res) => {
        this.loading.hide();
        let modalRef = this.modalService.open(ProductoUpdateComponent, { size: 'lg', scrollable: true, backdrop: 'static' });
        modalRef.componentInstance.element = res;
        modalRef.result.then((result: any) => {
          this.reloadEmitter.emit('true');
        }, (reason: any) => { });
      }, error: (err) => {
        this.loading.hide();
        if (err.error) this.formatter.showErrorAlerts(err.error);
      }
    });
  }

  cambiarEstado(element: any): void {
    this.loading.show()
    if (element.estado != 1) {
      this.service.activate(element).subscribe({
        next: (res: any) => {
          this.loading.hide();
          this.reloadEmitter.emit('true');
        },
        error: (err: any) => {
          console.error(err);
          this.loading.hide();
          this.alerts.addAlert("No se ha podido activar el registro.", "danger");
        }
      });
    } else {
      this.service.deactivate(element).subscribe({
        next: (res: any) => {
          this.loading.hide();
          this.reloadEmitter.emit('true');
        },
        error: (err: any) => {
          console.error(err);
          this.loading.hide();
          this.alerts.addAlert("No se ha podido desactivar el registro.", "danger");
        }
      })
    }



  }
  delete(element: any): void {
    let modalRef = this.modalService.open(ModalDeleteComponent, { size: 'lg', scrollable: true, backdrop: 'static' });
    modalRef.componentInstance.titulo = 'Eliminar Producto';
    modalRef.componentInstance.texto = `¿Está seguro de que desea eliminar el producto "${element.nombre}"?`;
    modalRef.componentInstance.textoAceptar = 'Eliminar';
    modalRef.result.then((result: any) => {
      this.loading.show()
      this.service.delete(element.id).subscribe({
        next: (res) => {
          this.loading.hide();
          this.reloadEmitter.emit('true');
          this.alerts.addAlert('El Producto se eliminó con éxito.', 'success');
        }, error: err => {
          console.error(err);
          this.loading.hide();
          if (err.error) this.formatter.showErrorAlerts(err.error);
        }
      });
    }, (reason: any) => { });
  }

  selectCategoria() {
    this.loading.show()
    let user = JSON.parse(localStorage.getItem('usuario') as string);
    this.categoriaService.select(user).subscribe({
      next: (res) => {
        this.loading.hide();
        for (let i = 0; i < res.length; i++) {
          this.filtros[3].options?.push({ label: res[i].nombre, value: res[i].id })
        }
      }, error: (err) => {
        console.error(err);
        this.loading.hide();
        this.alerts.addAlert("No se pudo Cargar Tipos de gastos de la empresa", "danger");
        console.log(err.error.response)
        if (err.error.response) {
          this.alerts.addAlert(err.error.response, "danger");
        }
      }
    })
  }
}
